/**
 * A small util for recursively generating a unique id for each tree item based
 * on the current depth within the tree and the index within the current list.
 *
 * @param treeId - The base id of the tree element
 * @param index - The current index of the item
 * @param parentIndexes - A list of parent indexes that are joined together with
 * `'-'` to generate the full id.
 * @internal
 */
export function getTreeItemId(treeId, index, parentIndexes) {
    if (parentIndexes === void 0) { parentIndexes = []; }
    if (!parentIndexes.length) {
        return "".concat(treeId, "-item-").concat(index + 1);
    }
    return "".concat(treeId, "-item-").concat(parentIndexes.join("-"), "-").concat(index + 1);
}
//# sourceMappingURL=getTreeItemId.js.map